module.exports = __webpack_public_path__ + "img/newicon5on.d1a4c1ad.svg";